export enum BusinessProfilePublication {
  /*
   * The profile is listed in the public
   * directory and discoverable by anyone.
   */
  PUB = "public",

  /*
   * The profile is private to company/store staffs
   */
  INTERNAL = "internal",

  /*
   * The profile visible to logged-in customers
   */
  CUSTOMER = "customer",

  /*
   * The profile visible to authenticated users
   */
  SENSITIVE = "sensitive",
}

export enum BusinessType {
  COMPANY = "company",
  INDIVIDUAL = "individual",
  NONPROFIT = "non_profit",
  GOVERNMENT_ENTITY = "government_entity",
}

export enum BusinessProfileType {
  BusinessProfile = "business_profile",
  EventProfile = "event_profile",
  ServiceProfile = "service_profile",
}
